// extracted by mini-css-extract-plugin
module.exports = {"notificationList":"NotificationList_notificationList__ivyV9","itemBlock":"NotificationList_itemBlock__BpMLw","itemDetail":"NotificationList_itemDetail__0rovh"};